// removed by extract-text-webpack-plugin
module.exports = {"OTA":"_1D203qIdyg74XZQusl17Qg","searchContainer":"Uch9xEHQnEDjCE_j_ezwI","formContainer":"_3w3Ed7LV_Ujlc895KXFbX2","bottomForm":"pocvt5eYj0A-J3xaz5Vlj"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/OTA/OTA.less
// module id = 1616
// module chunks = 0